import { type BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
import { type PaginatedResults } from "shared/api/types/pagination";
import { type SocietyDirectoryBodyInput } from "shared/api/types/society/[societyId]/directory";
import { type SocietyDirectoryParamsInput } from "shared/api/types/society/[societyId]/directory/[directoryId]/index";
import { type DirectoryView } from "shared/mappers/database/directory/directory";
import { type ProfileView } from "shared/mappers/database/profile/profile";
export const getSocietyDirectoryIdContract: BaseApiContract<
  SocietyDirectoryParamsInput,
  undefined,
  PaginatedResults<ProfileView, DirectoryView>
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/directory/[directoryId]",
  paramsType: {} as SocietyDirectoryParamsInput,
  responseType: {} as PaginatedResults<ProfileView, DirectoryView>,
};
export const postSocietyDirectoryIdContract: BaseApiContract<
  SocietyDirectoryParamsInput,
  SocietyDirectoryBodyInput,
  DirectoryView
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/directory/[directoryId]",
  paramsType: {} as SocietyDirectoryParamsInput,
  bodyType: {} as SocietyDirectoryBodyInput,
  responseType: {} as DirectoryView,
};
export const deleteSocietyDirectoryIdContract: BaseApiContract<
  SocietyDirectoryParamsInput,
  undefined,
  DirectoryView
> = {
  method: HttpMethod.DELETE,
  apiRoute: "/api/v1/society/[societyId]/directory/[directoryId]",
  paramsType: {} as SocietyDirectoryParamsInput,
  responseType: {} as DirectoryView,
};
